module.exports = __webpack_public_path__ + "static/media/change-direction.dc06ae30.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/nxbus/change-direction.svg
// module id = 230
// module chunks = 0